import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();
const load = () => {
  if (!cache) cache = api.get("/image-focus").then((r) => r.data).catch(() => ({}));
  return cache;
};
export const refreshFocus = () => { cache = null; load().then((m) => listeners.forEach((f) => f(m))); };

// Card crop for a photo URL or id: object-position + zoom, so the product stays in view.
export const useFocus = (src) => {
  const [map, setMap] = useState(null);
  useEffect(() => {
    let live = true;
    load().then((m) => live && setMap(m));
    listeners.add(setMap);
    return () => { live = false; listeners.delete(setMap); };
  }, []);
  const id = (src || "").match(/\/images\/([^/?]+)/)?.[1] || src;
  return focusStyle(map?.[id]);
};

export const focusStyle = (f) => (f ? { objectPosition: `${f.x}% ${f.y}%`, scale: String(f.zoom || 1), transformOrigin: `${f.x}% ${f.y}%` } : undefined);
